import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, CircularProgress } from "@material-ui/core";

import GeoLocDialog from "../modals/GeoLocDialog";
import { getKeywordsByLocation } from "../../store/slices/keywords";
import SkeletonMainSearch from "../skeletons/SkeletonMainSearch";
import useQuery from "../../hooks/useQuery";
import KeywordField from "./KeywordField";
import LocationField from "./LocationField";

const SearchForm = () => {

    const history = useHistory()
    const queryParams = useQuery();
    const dispatch = useDispatch();
    const { keywords, locations } = useSelector((state) => state.keywords);
    const [loader, setLoader] = useState(false);
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
  //  const [searchValue, setSearchValue] = useState(location.loc);
    const [data, setData] = useState({
        q: "",
        loc: "Karachi, Pakistan",
        lat: "24.860966",
        lng: "66.990501",
        radius: "25",
    });

    const handleDialogClose = () => {
        setDialogIsOpen(false);
    };

    useEffect(() => {
        setData({
            q: queryParams.get('q') === undefined ? "" : queryParams.get('q'),
            cat: queryParams.get('cat') === undefined ? "" : queryParams.get('cat'),
            loc: queryParams.get('loc') === undefined ? data.loc : queryParams.get('loc'),
            lat: queryParams.get('lat') === undefined ? data.lat : queryParams.get('lat'),
            lng: queryParams.get('lng') === undefined ? data.lng : queryParams.get('lng'),
            radius: queryParams.get('radius') === undefined ? data.radius : queryParams.get('radius'),
        });
    }, [queryParams.get('lat'), queryParams.get('lng')]);

    useEffect(() => {
        const recent = localStorage.getItem("recent");
        if(recent) {
            const recentt = JSON.parse(recent);
        
            const formData = new FormData();
            formData.append('loc', recentt.loc);
            formData.append('lat', recentt.lat);
            formData.append('lng', recentt.lng);
            formData.append('radius', recentt.radius);
            
            dispatch(getKeywordsByLocation(formData));

            setData((prevState) => ({
                ...prevState,
                q: recentt.q,
                loc: recentt.loc,
                lat: recentt.lat,
                lng: recentt.lng,
                radius: recentt.radius,
            }));
        } else {
            const formData = new FormData();
            formData.append('loc', data.loc);
            formData.append('lat', data.lat);
            formData.append('lng', data.lng);
            formData.append('radius', data.radius);
            
            dispatch(getKeywordsByLocation(formData));
        } 
    }, [dispatch]); 

    const handleSearch = () => {
        setLoader(true);
        localStorage.setItem("recent", JSON.stringify(data));

        history.push(`/search?q=${data.q}&loc=${data.loc}&lat=${data.lat}&lng=${data.lng}&radius=${data.radius}`)
        window.location.reload();
    };

    return (
        <>
            {keywords && locations && (
                <div className="main-search-input-wrap fl-wrap">
                    <KeywordField
                        data={data}
                        setData={setData} 
                    />
                    <LocationField 
                        data={data}
                        setData={setData} 
                        setLoader={setLoader}
                        setDialogIsOpen={setDialogIsOpen}
                    />
                    <div className="main-search-button-wrapper">
                        <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            onClick={handleSearch}
                        >
                            {loader && (
                                <CircularProgress color="inherit" size={24} />
                            )}
                            {!loader && "Search"}
                        </Button>
                    </div>
                </div> 
            )}
            {!keywords && !locations && (
                <div className="fl-wrap">
                    <SkeletonMainSearch />
                </div>
            )}

            <GeoLocDialog
                dialogIsOpen={dialogIsOpen}
                handleDialogClose={handleDialogClose}
                setDialogIsOpen={setDialogIsOpen}
            />
        </>
    );
};

export default SearchForm;
